import { Box } from "@mui/material";
import ReactHtmlParser from "react-html-parser";

const ArticleCopyrightStatement = (
    {
        statement
    }: {
        statement: {
            caption: string;
        }
    }
) => (
    <Box mt={1}>
        {
            ReactHtmlParser(
                statement.caption
            )
        }
    </Box>
);

export default ArticleCopyrightStatement;